var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#6B6D7A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.121 8.182L18 6l-2.182 3.879-1.697.848L12.848 12l1.273 1.273 1.697.848L18 18l-3.879-2.182-.848-1.697L12 12.848l-1.273 1.273-.848 1.697L6 18l2.182-3.879 1.697-.848L11.15 12 9.88 10.727 8.182 9.88 6 6l3.879 2.182.848 1.697L12 11.15l1.273-1.272.848-1.697z",
    fill: "#6B6D7A"
  })));
}

export default SvgCrossIcon3;